'use strict';

var Sugar = require('sugar-core');

require('./build/buildDateUnitMethodsCall');

module.exports = Sugar.Date.weeksUntil;


//////////////////
// WEBPACK FOOTER
// ./~/sugar-date/date/weeksUntil.js
// module id = 298
// module chunks = 1